import React from 'react'
import LoadingCell from './Loaders/LoadingCell';
import { QuestionnaireTableRow, QuestionnaireWithConditions } from './types';

export const headers: QuestionnaireTableRow = {
  view: {
    title: 'Questionnaire Title',
    conditions: 'Conditions that attached questionnaire'
  },
  headers: true
};

export const prepareLoadingData = (rowsPerPage: number) => {
  return Array.from({ length: rowsPerPage }).reduce<QuestionnaireTableRow[]>(
    data => {
      data.push({
        view: {
          title: <LoadingCell />,
          conditions: <LoadingCell />
        }
      });
      return data;
    },
    [headers]
  );
};

export const convertQuestionnairesToTable = (questionnaires: QuestionnaireWithConditions[]) => {
  if (!questionnaires) {
    return [];
  }

  return questionnaires.reduce(
    (data, questionnaire) => {
      const { _id, title, conditions } = questionnaire;

      data.push({
        view: {
          title,
          conditions: conditions.map(condition => condition.internal_name).join(', ')
        },
        ID: String(_id),
        route: 'questionnaires'
      });

      return data;
    },
    [headers]
  );
};
